module.exports = __webpack_public_path__ + "static/img/行业特性.187bc8ff.png";